window.addEventListener('load',function () {
    // 选择要观察变动的节点
  let targetNode = '';
  if(ShopifyAnalytics.meta.page.pageType == 'home'){
      targetNode = document.querySelector('.widget-product');
    }else{
      targetNode = document.querySelector('#CollectionProductGrid');
    }
    // 观察器的配置
    const config = { attributes: true, childList:true, subtree:true };
    // 创建一个观察器实例并传入回调函数
    const observer = new MutationObserver(hideEl);
    observer.observe(targetNode, config);
})

function hideEl(){
  const targetNode = document.querySelector('#CollectionProductGrid');
  const priceSelector = document.querySelectorAll('.price-regular');
  if(priceSelector.length>0){
    for(let i = 0; i<priceSelector.length;i++){
      if(priceSelector[i].innerText.replace(/[^\d\.]/g,'') == 0)
        {
          priceSelector[i].style.display = 'none';
          const el = getfatherElement(priceSelector[i]);
          const atcSelector = el.querySelector('.add-to-cart-btn');
          atcSelector.style.display = 'none';
          const absBtn = el.querySelector('.quickview-button');
          absBtn.style.display = 'none';
        }
    }
  }
}

function getfatherElement(sonelement) {
    var fathertag = sonelement;
    while (true) {
        var fathertag = fathertag.parentNode;//1级父节点
        if (fathertag.className == 'inner-top') {
            return fathertag;
            break;
        }
    }
}
